import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Sofort-Download', 'Keine Abo-Gebühren', 'Lebenslanger Zugriff', '7 Tage Geld-zurück-Garantie'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-99" data-mp="9l32h6xs621c">
      <div className="mx-auto max-w-4xl text-center" data-id="element-100" data-mp="4mi47d239sfj">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-101" data-mp="4jvvvb7dj8w9">
          Plane ein ganzes Jahr Yoga-Unterricht in nur{' '}
          <span className="italic text-brand" data-id="element-102" data-mp="nbf0fmh1qv0e">5 Minuten</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-103" data-mp="3d2labedjz91r">
          Schließe dich über 1.500 Yogalehrerinnen und Yogalehrern an, die aufgehört haben zu
          improvisieren. Geh in jede Klasse mit einem fertigen Plan, der inspiriert und Vertrauen
          schenkt.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-104" data-mp="3e84rvp627l0d">
          <img src="https://cdn.magicpatterns.com/uploads/khsrwgoF1nydUMrGAtNCxA/94b95cda-6e45-40bb-8d40-e137bbda10ef.webp" alt="Das YOGA BEREIT™ Paket: die sechs kompletten Bände von den Grundlagen bis zur Meisterschaft, inklusive digitaler Plattform für Desktop, Tablet und Smartphone sowie 5 exklusiven Strategie-Bonusmodulen" className="mx-auto w-[86%] max-w-xl sm:w-[80%]" data-id="element-105" data-mp="2qkda461r2frp" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-106" data-mp="s3cm2bn71lr3">
          <CtaButton href="#offer" data-id="element-107" data-mp="dd592bfyguxs" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-108" data-mp="de6n8os9pxjq">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-109" data-mp="161ja702cc7dk" data-mpi={index}>
                <span data-id="element-110" data-mp="112pvx5f8cccc">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-111" data-mp="114kj6qdz4gjl">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}